<template>
  <div></div>
</template>
<script>
export default {
  beforeRouteEnter(to, from, next) {
    // 解决全局通知进入待审核处方列表时 不会刷新的问题
    next(vm => {
      vm.$router.replace({ path: '/waitPrescriptionList' });
    });
  }
};
</script>
